import React from 'react'
import { Link } from 'react-router-dom'

const FourOhFour = () => {
  return (
    <div>
      <span className="text-4xl text-center font-semibold block min-h-screen">404 Not Found</span>
    </div>
  )
}
export default FourOhFour
